(function() {
    'use strict';

    /**
     * Helps manage the headings and cells in a Smart Table grid.
     * Can be used as an element when scrolling is not needed.
     *
     * @method alphaSmartTableBody
     *
     * @example
     *      HTML:
     *      <div alpha-smart-table-body
     *          columns="someGridColumns"></div>
     *
     * @param {Object[]} columns The full column configuration for the smart table
     * @param {Number} columns.ordinal The ordinal of each column
     * @param {Number} [columns.locked] Whether each column is locked
     */

    angular
        .module('alpha.common.alphaSmartTable')
        .directive('alphaSmartTableBody', alphaSmartTableBody);

    alphaSmartTableBody.$inject = ['AlphaSmartTableService'];

    function alphaSmartTableBody(AlphaSmartTableService,$timeout) {
        return {
            link: link,
            restrict: 'AE',
            scope: true
        };
        function link(scope, element, attrs) {
            var _columns;
            var tableName;
            var previousWidths = {};
            var previousTooltips = {};

            scope.getCellPositionCss = getCellPositionCss;
            scope.getFilterPositionCss = getFilterPositionCss;
            scope.showTooltip = {};

            scope.$watch(attrs.columns, function(newVal) {
                _columns = newVal;
            });
            scope.$watch(attrs.tableName, function(newVal){
                tableName = newVal;
            });
                // Public methods


            function getCellPositionCss(targetColumn,columnWidth, minColumnWidth) {
                if (targetColumn){
                        var columnElements = angular.element(element[0].querySelectorAll('.alpha-table-heading'));
                        angular.forEach(columnElements, function (columnElement) {
                                if (columnElement.id.toLowerCase().indexOf(targetColumn.name.toLowerCase()) !== -1 && columnElement.innerText !== ""  && columnElement.scrollWidth > columnElement.clientWidth) {
                                    scope.showTooltip[targetColumn.name] = true;
                              } else if (columnElement.id.toLowerCase().indexOf(targetColumn.name.toLowerCase()) !== -1 && columnElement.innerText !== "" &&  columnElement.scrollWidth <= columnElement.clientWidth) {
                                    scope.showTooltip[targetColumn.name] = false;
                              }
                    });
                }
                var lockedColumnOffset = _getLockedOffset(targetColumn);
                if (targetColumn && targetColumn.locked) {
                    return {
                        "width":_getWidth(columnWidth, minColumnWidth),
                        "left":lockedColumnOffset
                    }
                } else {
                    return {
                        "width": _getWidth(columnWidth, minColumnWidth)
                    }
                }

                function _getWidth(colWidth, minWidth) {
                    var colWidthNum = _.isNumber(colWidth) ? colWidth : parseInt(colWidth, 10),
                        minWidthNum = _.isNumber(minWidth) ? minWidth : parseInt(minWidth, 10);
                    if (_.isNaN(colWidthNum) || _.isNaN(minWidthNum)) {
                        return colWidth;
                    }
                    return colWidthNum < minWidthNum ? minWidthNum + 'px' : colWidthNum + 'px';
                }
            }

            function getFilterPositionCss(targetColumn,columnWidth, minColumnWidth) {
                var isMdGridViewColumn = _.get(targetColumn, 'mdGridColumnName') === 'VIEW';
                if (targetColumn.locked) {
                    return {
                        "width":_getWidth(columnWidth, minColumnWidth),
                        "left":_getLockedOffset(targetColumn),
                        "height": isMdGridViewColumn ? '100%' : 'fit-content'
                    }
                } else {
                    return {
                        "width": _getWidth(columnWidth, minColumnWidth)
                    }
                }
                function _getWidth(colWidth, minWidth) {
                    var colWidthNum = _.isNumber(colWidth) ? colWidth : parseInt(colWidth, 10),
                        minWidthNum = _.isNumber(minWidth) ? minWidth : parseInt(minWidth, 10);
                    if (_.isNaN(colWidthNum) || _.isNaN(minWidthNum)) {
                        return colWidth;
                    }
                    return colWidthNum < minWidthNum ? minWidthNum + 'px' : colWidthNum + 'px';
                }
            }

            // Private functions

            function _getLockedOffset(targetColumn) {
                var offset = 0;
                offset += _.sum(_.map(_getPrecedingColumns(targetColumn), function(column) {
                    return parseInt(column.width);
                }));
                return offset + 'px';
            }
            function _getUnlockedOffset(targetColumn) {
                var offset = 0;
                if (_getPrecedingColumn(targetColumn).locked) {
                    offset = _.sumBy(_getLockedColumns(), function(column) {
                        return parseInt(column.width);
                    });
                }
                return offset + 'px';
            }
            function _getPrecedingColumns(targetColumn) {
                if(!targetColumn){
                    return [];
                }
                return _.filter(_columns, function(column) {
                    return column.visible && column.ordinal < targetColumn.ordinal;
                });
            }
            function _getPrecedingColumn(targetColumn) {
                return _.maxBy(_getPrecedingColumns(targetColumn), 'ordinal') || {};
            }
            function _getLockedColumns() {
                return _.filter(_columns, {locked: true, visible: true}) || [];
            }
        }
    }
})();
